<template>
  <div id="form">
    <h2>Lückentext</h2>
    <br><br>
    <p style="text-align: left;">
        Beim Übergang von Außenohr zu Mittelohr findet ein Wechsel des Schall Leitenden Mediums, Luft → Lymphe, statt und damit geht auch ein Wechsel von akustischer Impdeanzen einher. <br>
        Aufgrund der unterschiedlichen Schallwellenwiderstände würde so theoretisch etwa 98% der auftreffenden Schallwellen reflektiert werden, was die genannte Impedanzanpassung so wichtig macht. <br>
        
    </p>
    <p style="text-align: left;">
        Durch diese Anpassung kann die Reflexion auf ca <input v-model="message1" placeholder="Feld1" /> % gesenkt werden. 
        Hebelwirkung (Faktor <input v-model="message2" placeholder="Feld2" />) und Flächenverhältnis (Faktor <input v-model="message3" placeholder="Feld3" />)
        ergeben eine Gesamtverstärkung von ca <input v-model="message4" placeholder="Feld4" /> (frequenzabhängig).
    </p>

    <button id="button2" v-on:click="check">
        Prüfen
    </button>

  </div>
</template>
<script>

export default {
  name: "two-lists",
  display: "Two Lists",
  order: 1,

  data() {
    return {
        message1: '',
        message2: '',
        message3: '',
        message4: '',
    }
  },
  methods: {
    log: function(evt) {
      window.console.log(evt);
    },
    check() {
        if ( ((this.message1 && this.message1 == "40" || this.message1 == "vierzig") &&
             (this.message2 && this.message2 == "1,3" || this.message2 == "1.3") &&
             (this.message3 && this.message3 == "14" || this.message3 == "vierzehn") &&
             (this.message4 && this.message4 == "15" || this.message4 == "fünfzehn"))
            ){
                alert("richtig");
                this.$store.commit('setTaskCompletionState', {varname: "aufbauForm3_done", state: true})
                localStorage.setItem("aufbauForm3_done", true);
            }
        else {
            alert("falsch")
        }
    }
  }
};
</script>

<style scoped>
/* #input1 {
    position: absolute;
    left: 260px;
    top: 305px
} */
/* #input2 {
    position: absolute;
    left: 530px;
    top: 205px
} */

#button2 {
    position: absolute;
    left: 650px;
    top: 550px;
    font-family: sans-serif;
    font-size: 20px;
    /* background-color: #297; */
    color: #fff;
    border: 0px;
    border-radius: 3px;
    padding: 20px;
    cursor: pointer;
    margin-bottom: 20px;
    background-color: #528382
}
#form {
    height: 1000px;;
}
</style>